import { render, staticRenderFns } from "./ModalBox.vue?vue&type=template&id=e641e508&scoped=true&"
import script from "./ModalBox.vue?vue&type=script&lang=js&"
export * from "./ModalBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e641e508",
  null
  
)

export default component.exports